import { trackRetainAttempted } from '@/utils/eventTracking';

declare global {
  interface Window {
    Paddle: any;
  }
}

export const initializePaddle = (paddleCustomerId?: string) => {
  if (typeof window === 'undefined') return;

  // Set environment (sandbox for development)
  if (import.meta.env.DEV) {
    window.Paddle.Environment.set('sandbox');
  }

  // Build pwCustomer object - include if paddleCustomerId is provided, otherwise empty object
  const pwCustomer = paddleCustomerId ? { id: paddleCustomerId } : {};

  // Initialize Paddle with your client token
  window.Paddle.Initialize({
    token: import.meta.env.VITE_PADDLE_CLIENT_TOKEN,
    pwCustomer: pwCustomer,
    eventCallback: function (data: any) {
      console.log('Paddle event:', data);
    }
  });
};

export const cancelSubscription = (subscription_id: string, onComplete?: (result: any) => void) => {
  try {
    // Retain returns a promise, allowing .then() chaining for post-cancellation workflows
    const promise = window.Paddle.Retain.initCancellationFlow({
      subscription_id: subscription_id
    });

    // Log the Retain Attempted event with all properties from Paddle
    promise.then((result: any) => {
      // Track the retain attempt with all properties from the Paddle response
      trackRetainAttempted(
        result.status || null,
        result.salvageAttemptResult || null,
        result.salvageOfferResult || null,
        result.additionalFeedback || null,
        result.cancelReason || null,
        result.satisfactionInsight || null,
        result.salvageAttemptIntended || null,
        result.salvageAttemptUsed || null
      );

      // Call the user's onComplete callback if provided
      if (onComplete && typeof onComplete === 'function') {
        onComplete(result);
      }
    }).catch((error: any) => {
      console.error('Failed to cancel subscription:', error);
      throw error;
    });

    return promise;
  } catch (error) {
    console.error('Failed to cancel subscription:', error);
    throw error;
  }
};

export const openSubscriptionCheckout = async (
  customerId: string,
  name: string,
  customerEmail: string,
  priceId: string
) => {
  try {
    return window.Paddle.Checkout.open({
      items: [{
        priceId: priceId,
        quantity: 1
      }],
      customer: {
        email: customerEmail,
        name: name
      },
      settings: {
        displayMode: 'overlay',
        theme: 'light',
        locale: 'en',
        successUrl: `${window.location.origin}/profile?active=subscription&reload=true`,
      },
      customData: {
        "user_id": customerId
      }
    });
  } catch (error) {
    console.error('Failed to open checkout:', error);
    throw error;
  }
};
